import Checkbox from './Checkbox.web';
import CheckboxItem from './CheckboxItem.web';
import AgreeItem from './AgreeItem.web';

Checkbox.CheckboxItem = CheckboxItem;
Checkbox.AgreeItem = AgreeItem;

export default Checkbox;



/** WEBPACK FOOTER **
 ** ./components/checkbox/index.web.tsx
 **/